import Flickity from "flickity";

const Testimonials = () => {

    // Find all sliders on the page with the given class selector
    const testimonials = document.querySelectorAll('.testimonials__slides');

    // Loop through each slider and initialize Flickity if it has multiple slides
    testimonials.forEach(slider => {
        const slideCount = slider.querySelectorAll('.testimonials__slide').length;
        const hasMultipleSlides = slideCount > 1;


        if (hasMultipleSlides) {
            const flickity = new Flickity(slider, {
                adaptiveHeight: false,
                autoPlay: false,
                cellSelector: '.testimonials__slide',
                draggable: true,
                fade: false,
                pageDots: true,
                prevNextButtons: false,
                wrapAround: true,
            });
        }
    });
}
  
export default Testimonials;
